module.exports = {
    apiDomain: "https://h63.cnnd.vn/Widget",
}